import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";
import { ArrowDown } from "lucide-react";

const FLOW = ["Search", "Visibility", "Traffic", "Leads", "Revenue"];

export function Positioning() {
  return (
    <section className="py-16 sm:py-24 lg:py-32" data-testid="positioning-section">
      <div className="container-rw grid items-center gap-14 lg:grid-cols-2">
        <SectionHead
          eyebrow="Why SEO"
          title={<>SEO is not a checkbox.<br /><span className="text-rw-green">It's a growth system.</span></>}
          description="Businesses don't need another agency offering everything. They need a specialist who understands how search works — from crawling and indexing to content, authority, local visibility and conversion."
          testid="positioning-head"
        />
        <Reveal delay={0.15}>
          <div className="relative mx-auto max-w-sm">
            {FLOW.map((step, i) => (
              <div key={step}>
                <Reveal delay={0.1 + i * 0.12}>
                  <div
                    className={`flex items-center justify-between rounded-xl border px-6 py-4 ${
                      i === FLOW.length - 1
                        ? "border-rw-green/50 bg-rw-green/10 glow-green"
                        : "border-rw-border bg-rw-card"
                    }`}
                    data-testid={`flow-step-${step.toLowerCase()}`}
                  >
                    <span className="font-mono text-xs text-rw-dim">0{i + 1}</span>
                    <span className={`font-jakarta font-bold text-lg ${i === FLOW.length - 1 ? "text-rw-green" : "text-rw-text"}`}>
                      {step}
                    </span>
                  </div>
                </Reveal>
                {i < FLOW.length - 1 && (
                  <div className="flex justify-center py-1 text-rw-green/60" aria-hidden="true">
                    <ArrowDown size={16} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
